@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
<div class="content">
  <div class="toolbar">
    <span class="modmessage">Mod units can only be released through the "Release Mods" interface.</span>
    <span>
      <label class="quantityLabel">Release Quantity: {{ totalQuantity }}</label>
      <button matButton="text" [disabled]="isBusy() || totalQuantity === 0" (click)="generateRelease()">
        <span>
          <mat-icon>done</mat-icon>
          <label>Generate Release</label>
        </span>
      </button>
    </span>
  </div>
  <div class="tableWrapper">
    <table class="reportTable">
      <thead>
        <td class="tableCell headerCell centeredCell">Line</td>
        <td class="tableCell headerCell centeredCell">Description</td>
        <td class="tableCell headerCell centeredCell">Tags</td>
        <td class="tableCell headerCell centeredCell">Available</td>
        <td class="tableCell headerCell centeredCell">Quantity</td>
      </thead>
      @if (releaseLines() && releaseLines().length > 0) {
        @for (line of releaseLines(); track line) {
          <tr>
            @if (!line.mod || (line.mod && !line.configured)) {
              <td class="tableCell">{{ line.lineId }}</td>
              <td class="tableCell">{{ line.lineDescription }}</td>
              <td class="tableCell wideCell">{{ line.externalNotes }}</td>
              <td class="tableCell centeredCell">{{ line.availableQuantity }}</td>
              <td class="tableCell">
                <input class="inputField standardTextBox" [(ngModel)]="line.quantityToRelease"
                  (blur)="updateQuantity(line)"/>
              </td>
            }
          </tr>
        }
      }
      @if (!releaseLines() || releaseLines().length === 0) {
        <tr>
          <td class="tableCell" colspan="5">No lines were found to release</td>
        </tr>
      }
    </table>
  </div>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
